import api from "@/plugins/api";
/**
 * Creates a new identifier for a contact.
 *
 * Hits `POST /api/v1/contacts/{contactId}/identifiers` and returns the new
 * identifier id. `unwrapEnvelope: true` unwraps the `ApiResponse<Guid>` envelope so
 * `response.data` is the id directly. A duplicate type surfaces as a rejected
 * promise (409) the caller turns into an inline error + toast.
 */
export async function createContactIdentifier(contactId, payload) {
    const response = await api.post(`/contacts/${contactId}/identifiers`, payload, { unwrapEnvelope: true });
    return response.data;
}
/**
 * Updates an existing identifier of a contact.
 *
 * Hits `PUT /api/v1/contacts/{contactId}/identifiers/{id}` and returns the
 * identifier id. `unwrapEnvelope: true` unwraps the `ApiResponse<Guid>` envelope.
 */
export async function updateContactIdentifier(contactId, id, payload) {
    const response = await api.put(`/contacts/${contactId}/identifiers/${id}`, payload, { unwrapEnvelope: true });
    return response.data;
}
/**
 * Deletes an identifier of a contact.
 *
 * Hits `DELETE /api/v1/contacts/{contactId}/identifiers/{id}` (BFF returns 204).
 */
export async function deleteContactIdentifier(contactId, id) {
    await api.delete(`/contacts/${contactId}/identifiers/${id}`, { unwrapEnvelope: true });
}
